import { Box, withCitrusTheme } from '@gousto-internal/citrus-react';

export const VideoColumn = withCitrusTheme(Box, (theme) =>
  theme.responsiveStyle([2, null, 0], ['order']),
);
